import React from 'react';
import './LoyaltyFold.css';
import { useTranslations } from '../../hooks/use-translations.hook';
import { DefaultLoyaltyService } from '../../../../loyalty/src/services/default-loyalty.service';
import { GeneralLoyaltyDataService } from '../../../../loyalty/src/services/general-loyalty-data.service';
import { LoyaltyPlansEnum } from '../../../../loyalty/src/enums/loyalty-plans.enum';

export const LoyaltyFold = ({
    userLoyaltyPoints,
    clickHandler,
    className = '',
}) => {
    if (!userLoyaltyPoints || !clickHandler) {
        return null;
    }

    const currentLevelNumber = userLoyaltyPoints?.CurrentLevelNumber;
    if (!currentLevelNumber) {
        Tools.error('User loyalty data missed', userLoyaltyPoints);
        return null;
    }

    const { t } = useTranslations();
    const {
        currentLevelName,
        currentLevelSlug,
        currentLevelColor,
        currentLevelIconUrl,
        nextLevelName,
        totalLevelsNum,
    } = DefaultLoyaltyService.getLoyaltyFoldData(currentLevelNumber);
    const isLastLevel = currentLevelNumber === totalLevelsNum;

    const loyaltyPlan = GeneralLoyaltyDataService.getLoyaltyPlan();
    const currentLevelNameStyles = loyaltyPlan === LoyaltyPlansEnum.EDITABLE_DEFAULT
        ? {}
        : { color: currentLevelColor };

    const wrapperClasses = [
        'loyalty-fold__wrapper',
        loyaltyPlan,
        currentLevelSlug,
        className,
    ].join(' ');

    return <div
        className={wrapperClasses}
        onClick={clickHandler}
    >
        <div className="asg-loyalty-fold__left-column">
            <div className="loyalty-level"
                style={currentLevelNameStyles}>
                {currentLevelName}
            </div>
            {!isLastLevel && <>
                <div className="loyalty-next-level">
                    {`${t('nextLevel')}: `}
                    <span>{nextLevelName}</span>
                </div>
                <div className="loyalty-progress-bar-wrapper" >
                    <div className="loyalty-progress-bar"
                        style={{
                            width: `${userLoyaltyPoints.ProgressPercentForNextLevel}%`,
                            backgroundColor: currentLevelColor,
                        }}
                    ></div>
                </div>
            </>}
        </div>
        <div className="asg-loyalty-fold__right-column">
            <div
                className="asg-loyalty-fold__crown"
                style={{
                    backgroundColor: currentLevelColor,
                    maskImage: `url(${currentLevelIconUrl})`,
                    WebkitMaskImage: `url(${currentLevelIconUrl})`,
                }}>
            </div>
        </div>
    </div>;
};
